import Service from "../../../Services/index";

const RealizedGainLoss = {
    namespaced: true,
    state: {
        realized_list: [],
        realized_form: null,
    },
    mutations: {
        SET_REALIZED_GAIN_LOSS_LIST: (state, res) => {
            state.realized_list = res.data;
        },
        SET_REALIZED_GAIN_LOSS_FORM: (state, res) => {
            state.realized_form = res;
        },
    },
    actions: {
        getRealizedGainLossList({commit}, page = 1) {
            return Service.RealizedGainLoss.getRealizedGainLoss().then(data => {
                commit("SET_REALIZED_GAIN_LOSS_LIST", data);
            })
        },
        showRealizedGainLoss({commit}, id) {
            return Service.RealizedGainLoss.getRealizedGainLossById(id).then(data => {
                commit("SET_REALIZED_GAIN_LOSS_FORM", data);
            })
        },
        saveRealizedGainLoss({commit}, {id, data}) {
            if (!id) {
                return Service.RealizedGainLoss.createRealizedGainLoss(data);
            } else {
                return Service.RealizedGainLoss.updateRealizedGainLoss(id, data);
            }
        },
        deleteRealizedGainLoss({commit}, id) {
            return Service.RealizedGainLoss.deleteRealizedGainLoss(id)
        },
        getRealizedGainLossPerMonth({commit}, {month, year}) {
            //console.log(month,year);
            return Service.RealizedGainLoss.getRealizedGainLossPerMonth(month, year).then(data => {
                commit("SET_REALIZED_GAIN_LOSS_FORM", data);
            })
        }
    }
};

export default RealizedGainLoss
